





























































































































































































































































































import Vue from 'vue';
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex';

import shipmentsService from '@/services/ShipmentsService';
import sessionStorageService from '@/services/SessionStorageService';
import domService from '@/services/DOMService';
import shipmentUtils from '@/utils/ShipmentUtils';
import miscService from '@/services/MiscService';
import exportService from '@/services/ExportService';
import cookiesService from '@/services/CookiesService';

import { animationMixin } from '@/mixins/animation';
import { iconsMixin } from '@/mixins/icons';
import { authMixin } from '@/mixins/auth';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { myShipmentsMixin } from '@/mixins/shipments/myShipments';
import { formatMixin } from '@/mixins/format';

import { ShipmentSearch } from '@/models/shipments/search/ShipmentSearch';
import { ShipmentsSearchOptions } from '@/models/shipments/ShipmentsSearchOptions';
import { OverriddenColumn } from '@/models/misc/OverriddenColumn';

export default Vue.extend<any, any, any, any>({
  name: 'my-shipments',
  mixins: [
    iconsMixin,
    breakpointsMixin,
    authMixin,
    animationMixin,
    myShipmentsMixin,
    formatMixin,
  ],
  data() {
    return {
      pageSize: 20,
      totalCount: 0,
      shipments: [] as ShipmentSearch[],
      page: [] as ShipmentSearch[],
      loading: false as Boolean,
      loadingMsg: null,
      deleting: false as Boolean,
      cancelling: false as Boolean,
      undeleting: false as Boolean,
      currentPage: 1,
      currentShipmentId: null,
      shipmentCancelFailedInfo: null,
      showShipmentCancelFailedPopup: false,
      showShipmentSuccessfullyCancelledPopup: false,
      currentCancellationState: null,

      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      displayFilters: false,
      displayDetails: false,
      displayConfirmDelete: false,
      displayConfirmCancel: false,
      displayConfirmUndelete: false,
      displayMakeCopy: false,
      displayNoTracking: false,
      displayDocuments: false,
      selectedShipment: null as ShipmentSearch,

      availableTabs: [
        'Pending Orders',
        'Booked Shipments',
        'Shipment Reports',
        'Deleted',
      ],
      currentTab: 'Booked Shipments',
      quickSearchTerm: null,
      showStatusDefinitions: false,
      showAddIncidentPopup: false,
      showResendShipmentConfirmPopup: false,
      miniMap: true,
      showMap: false,
      combining: false,
      rerenderMergeWindow: 0,
      showExtractDataByAccount: false,
      showScheduleShipmentPopup: false,
      scheduleShipmentId: false,
      isDefaultLayout: true,
      gridRenderKey: 0,
      resizeTimeout: null,
    };
  },
  mounted() {
    this.setSavedTabAndQuickSearch();
    this.savedSearch();
    this.setupLayout();
  },
  beforeDestroy() {
    // Clean up event listeners
    EventBus.$off('grid-mode-changed', this.changeLayout);
    EventBus.$off('show-map-changed', this.changeMapVisibility);

    // Clear any pending timeouts
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = null;
    }
  },
  methods: {
    setupLayout() {
      EventBus.$on('grid-mode-changed', this.changeLayout);
      EventBus.$on('show-map-changed', this.changeMapVisibility);
      this.isDefaultLayout = cookiesService.get('gridMode') != 'true';
      this.showMap = cookiesService.get('showMap') == 'true';
      if (this.showMap) {
        this.miniMap = false;
      }
    },
    changeLayout() {
      const newIsDefaultLayout = cookiesService.get('gridMode') != 'true';

      // Only proceed if layout actually changed
      if (this.isDefaultLayout === newIsDefaultLayout) {
        return;
      }

      this.isDefaultLayout = newIsDefaultLayout;

      // When switching to cards mode (grid mode off), always minimize the map
      if (this.isDefaultLayout) {
        // If map is currently shown in full screen, hide it
        if (this.showMap) {
          this.showMap = false;
          cookiesService.set('showMap', 'false');
        }
        // Always ensure map is minimized in cards mode
        this.miniMap = true;
      }

      // Debounce map resize to prevent multiple rapid events
      this.debouncedMapResize();
    },
    changeMapVisibility(value) {
      this.showMap = value;
      if (value) {
        this.miniMap = false;
      }

      // Debounce map resize to prevent multiple rapid events
      this.debouncedMapResize();
    },
    debouncedMapResize() {
      // Clear any existing timeout
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      // Set a new timeout to emit the resize event after state has settled
      this.resizeTimeout = setTimeout(() => {
        this.$nextTick(() => {
          EventBus.$emit('map-resized', this.miniMap);
        });
        this.resizeTimeout = null;
      }, 150); // Wait 150ms for state to settle
    },
    setSavedTabAndQuickSearch() {
      const savedSearch = sessionStorageService.get('shipments-search-options');
      if (savedSearch != null && savedSearch.type != null) {
        this.currentTab = savedSearch.type;
      }

      if (savedSearch != null && savedSearch.shipmentId != null) {
        this.quickSearchTerm = savedSearch.shipmentId;
      }
    },
    csvExportV2() {
      this.loading = true;
      let options = sessionStorageService.get('shipments-search-options');
      if (options == null) {
        options = new ShipmentsSearchOptions();
      }

      shipmentsService
        .search(options)
        .then((x) => {
          let data = x || [];

          if (data.length) {
            data.forEach((x: any) => {
              const isLate = shipmentUtils.isLate(x);
              x.performance = isLate ? 'LATE' : 'ON TIME';

              if (!x.customerReference) x.customerReference = '';
              if (!x.reportedIssues) x.reportedIssues = '';
            });
          }

          const overrides = [
            new OverriddenColumn('Pickup Date', 'Act Pickup'),
            new OverriddenColumn('Delivery Date', 'Act Delivery'),
            new OverriddenColumn('Performance', 'ETA'),
          ];

          if (miscService.isWatsco(this.user?.accountId)) {
            overrides.push(
              new OverriddenColumn(
                'Customer Reference',
                'Order/Transfer/Vendor Return #'
              )
            );
          }

          exportService.csvDownload(
            data,
            'My Shipments',
            shipmentUtils.myShipmentsCsvColumnsOrder(),
            overrides
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyOrderIds(value) {
      this.snackbarText = `Order ID(s) copied to clipboard (${value})`;
      this.snackbar = true;

      domService.copyToClipboard(value);
    },
    copyBookedId(value) {
      this.snackbarText = `Shipment BOL Number copied to clipboard (${value})`;
      this.snackbar = true;

      domService.copyToClipboard(value);
    },
    unmerged(ids) {
      this.snackbarText = `The pending orders have been unmerged and are now searchable: ${ids}`;
      this.snackbar = true;
    },
    combineOrdersClosed() {
      this.combining = false;
      EventBus.$emit('map-reload');

      // reload map
      const selection = this.selectedShipments;
      this.$store.commit('consolidation/resetSelection');
      selection.forEach((x) => {
        this.$store.commit('consolidation/addSelectedItem', x);
      });
    },
    tabClicked(tab: string) {
      this.currentTab = tab;

      // update saved search
      let savedSearch = sessionStorageService.get('shipments-search-options');
      if (!savedSearch) savedSearch = new ShipmentsSearchOptions();
      savedSearch.type = tab;
      sessionStorageService.set('shipments-search-options', savedSearch);

      this.savedSearch();
    },
    quickSearch() {
      if (!this.quickSearchTerm) {
        return;
      }

      const options = new ShipmentsSearchOptions();
      options.type = this.currentTab;
      options.shipmentId = this.quickSearchTerm;
      this.currentPage = 1;

      // update saved search
      sessionStorageService.set('shipments-search-options', options);
      this.search(options);
    },
    toggleMap() {
      this.miniMap = !this.miniMap;
      this.scrollTo('map-wrapper');
      this.debouncedMapResize();
    },
    search(options) {
      // hack to hide autocomplete dropdowns from filters popup
      domService.bodyClick();

      this.displayFilters = false;
      this.loading = true;
      this.loadingMsg = 'Loading shipments...';
      if (options == null) {
        options = new ShipmentsSearchOptions();
      }

      // search type
      options.type = this.currentTab;

      // landstar check
      this.landstarCheck(options);

      shipmentsService
        .searchWithPaging(options, this.currentPage)
        .then((x: any) => {
          this.shipments = x.data;
          this.page = x.data;
          this.totalCount = x.totalCount;
          this.loading = false;

          // show snack bar
          this.showJustSavedShipmentMessage();
        });
    },
    combine() {
      this.rerenderMergeWindow++;
      this.$store.commit('consolidation/resetState');

      if (!this.canMergeManually && !this.canMergeWithAI) {
        this.$toast.error(
          'Please select at least two pending orders to merge.'
        );
        return;
      }

      this.combining = true;
    },
    clearSelection() {
      this.$store.commit('consolidation/resetSelection');
      EventBus.$emit('reset-selected-cards');
    },
    incidentReported(id) {
      this.currentShipmentId = id;
      this.showAddIncidentPopup = true;
    },
    newIncidentSaved() {
      this.showAddIncidentPopup = false;
      this.tabClicked(this.currentTab);

      this.snackbarText = `Service Incident has been reported for shipment ${this.currentShipmentId}.`;
      this.snackbar = true;
      this.currentShipmentId = null;
    },
    resendShipmentConfirmPopup(id) {
      this.showResendShipmentConfirmPopup = true;
      this.currentShipmentId = id;
    },
    shipmentConfirmationEmailSent() {
      this.showResendShipmentConfirmPopup = false;

      this.snackbarText = `Shipment confirmation email has been sent for shipment ${this.currentShipmentId}.`;
      this.snackbar = true;
      this.currentShipmentId = null;
    },
    closeShipmentConfirmationPopup() {
      this.showResendShipmentConfirmPopup = false;
      this.currentShipmentId = null;
    },
    dataExtractByAccount() {
      this.showExtractDataByAccount = true;
    },
    dataExtractedSuccessfully() {
      this.snackbarText =
        'Data has been exported successfully. Please check your downloads.';
      this.snackbar = true;
    },
    noData() {
      this.snackbarText =
        'Sorry, there are no shipments that match your search criteria.';
      this.snackbar = true;
    },
    openSchedulePopup(id) {
      this.showScheduleShipmentPopup = true;
      this.scheduleShipmentId = id;
    },
    closeScheduleShipmentPopup() {
      this.showScheduleShipmentPopup = false;
      this.scheduleShipmentId = null;
    },
    rejectError() {
      this.snackbarText = 'Sorry, there was an error rejecting this shipment.';
      this.snackbar = true;
    },
    loadScheduled() {
      this.savedSearch();
      this.snackbarText = 'Shipment has been scheduled and saved.';
      this.snackbar = true;
    },
  },
  computed: {
    ...mapGetters('consolidation', [
      'selectedShipments',
      'consolidationPopupWidth',
    ]),
    showCards() {
      return this.isDefaultLayout;
    },
    showGrid() {
      return !this.isDefaultLayout;
    },
    mapOrder() {
      if (this.smAndDown) {
        return 1;
      }

      // When in grid mode with map shown, always show map first
      if (this.showGrid && this.showMap) {
        return 1;
      }

      return this.miniMap ? 2 : 1;
    },
    cardsOrder() {
      if (this.smAndDown) {
        return 2;
      }

      // When in grid mode with map shown, always show grid second
      if (this.showGrid && this.showMap) {
        return 2;
      }

      return this.miniMap ? 1 : 2;
    },
    pageComputed() {
      return this.page;
    },
    mapKey() {
      return this.$route.path?.length;
    },
    showCombine() {
      return this.currentTab == 'Pending Orders';
    },
    showMergeWindow() {
      return this.combining && (this.canMergeManually || this.canMergeWithAI);
    },
    canMergeManually() {
      return this.selectedShipments.length > 1;
    },
    canMergeWithAI() {
      return (
        this.selectedShipments.length == 0 ||
        (!this.canMergeManually && this.combining)
      );
    },
    shipmentCancelFailedInfoComputed() {
      return this.shipmentCancelFailedInfo;
    },
    currentCancellationStateComputed() {
      return this.currentCancellationState;
    },
  },
  watch: {
    combining() {
      if (
        this.combining &&
        !this.selectedShipments.length &&
        !this.canMergeWithAI
      ) {
        this.combining = false;
      }
    },
  },
});
